import { Drawer, Flex } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBell, IconBellRinging } from "@tabler/icons-react";
import { useNotifications } from "hooks/useNotifications";
import { useTranslation } from "react-i18next";
import ImportantNotificationModal from "./ImportantNotificationModal/ImportantNotificationModal";
import NotificationLayout from "./NotificationLayout";
import Notifications from "./Notifications";

const NotificationWidget: React.FC = () => {
  const { t } = useTranslation("notifications");

  const { isSuccess, data } = useNotifications();

  const [opened, { toggle, close }] = useDisclosure(false);

  const amountOfNewNotification = data?.newNotifications.length ?? 0;

  const importantNotifications = data?.importantNotifications ?? [];

  return (
    <>
      {importantNotifications.length !== 0 && (
        <ImportantNotificationModal
          key={
            importantNotifications[0].id + importantNotifications[0].contextId
          }
          notification={importantNotifications[0]}
        />
      )}
      <Flex
        component="button"
        w={38}
        h={38}
        justify={"center"}
        align={"center"}
        className="relative cursor-pointer"
        onClick={toggle}
      >
        {amountOfNewNotification > 0 ? (
          <>
            <Flex
              justify={"center"}
              align={"center"}
              fz={12}
              w={13}
              h={13}
              className={
                " bg-red absolute top-2 left-1 text-white rounded-full"
              }
            >
              {amountOfNewNotification}
            </Flex>
            <IconBellRinging className={"text-red"} size={25} />
          </>
        ) : (
          <IconBell size={25} />
        )}
      </Flex>
      <Drawer
        withCloseButton={false}
        closeOnClickOutside={false}
        onClose={close}
        opened={opened}
        size={"100%"}
        position="top"
        classNames={{ body: "!p-0 !pt-0" }}
      >
        <NotificationLayout goBack={close} title={t("announcements")}>
          {isSuccess && <Notifications data={data} />}
        </NotificationLayout>
      </Drawer>
    </>
  );
};

export default NotificationWidget;
